/**
 * Point on a rendered SVG path at horizontal position `x`, clamped to the
 * path's x-range. Binary search over path length is only valid for
 * x-monotone paths (e.g. monotone-x / Catmull-Rom curves over x-sorted
 * points). Sampling the real path (instead of lerping between data points)
 * keeps a hover dot exactly on the drawn curve.
 */
export function pointOnPathAtX(path: SVGPathElement, x: number): DOMPoint {
  const total = path.getTotalLength();
  const start = path.getPointAtLength(0);
  const end = path.getPointAtLength(total);
  if (total === 0 || x <= start.x) return start;
  if (x >= end.x) return end;
  let lo = 0;
  let hi = total;
  while (hi - lo > 0.5) {
    const mid = (lo + hi) / 2;
    if (path.getPointAtLength(mid).x < x) lo = mid;
    else hi = mid;
  }
  return path.getPointAtLength((lo + hi) / 2);
}
